module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAQCAYAAAD52jQlAAAACXBIWXMAAAsSAAALEgHS3X78AAABJElEQVQ4jaWUvUoDURCFz9xMFrdQFoIs+A9KFCx9rNS+hDY2FnZ2til8DRErVzSYaAwkyyZZYffmGt2xyEbS2GQ+mPbjnBkYurppXiTJuCEAQwkB37VacMnJMG0cHezx1kaodaLb63PU6jQYIryzGeL4sA4RWT4lEQwB0Uub/yqLiEq6CFeZYAzBY4LGSTTzVJnA17cx7nsptndH6vpvnREe7gbgqG3xszpBN3Nqaf9jgufXHDyPbQyU9QFD5RqW1/wPCxkU5Qh09QsyECLwSf6IeuJhvfKu3ulg2MWafQI1A5L9wEfoVxU5AQLQt1O0xhbsCHDGg6usqKXOEBzZ2ROhcjQsOlgAm7ovX3OkOZ9uCgEylkLO49yexrn1tVIBsqKQs1/2I4CR7ys2/AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/LangSelector/flag-ru.png
// module id = 2285
// module chunks = 1